/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Page_Step_1Inputs */

const en_invite_page_step_1 = /** @type {(inputs: Invite_Page_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share your invite code`)
};

const ar_invite_page_step_1 = /** @type {(inputs: Invite_Page_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شارك رمز الدعوة الخاص بك`)
};

const de_invite_page_step_1 = /** @type {(inputs: Invite_Page_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile deinen Einladungscode`)
};

const es_invite_page_step_1 = /** @type {(inputs: Invite_Page_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte tu código de invitación`)
};

const fr_invite_page_step_1 = /** @type {(inputs: Invite_Page_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partagez votre code d’invitation`)
};

const it_invite_page_step_1 = /** @type {(inputs: Invite_Page_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi il tuo codice invito`)
};

const ja_invite_page_step_1 = /** @type {(inputs: Invite_Page_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待コードを共有する`)
};

const ko_invite_page_step_1 = /** @type {(inputs: Invite_Page_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대 코드 공유하기`)
};

const pt_br_invite_page_step_1 = /** @type {(inputs: Invite_Page_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhe seu código de convite`)
};

const ru_invite_page_step_1 = /** @type {(inputs: Invite_Page_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поделитесь своим кодом приглашения`)
};

const th_invite_page_step_1 = /** @type {(inputs: Invite_Page_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แชร์รหัสเชิญของคุณ`)
};

const tr_invite_page_step_1 = /** @type {(inputs: Invite_Page_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet kodunu paylaş`)
};

const zh_cn_invite_page_step_1 = /** @type {(inputs: Invite_Page_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享你的邀请码`)
};

const zh_tw_invite_page_step_1 = /** @type {(inputs: Invite_Page_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享你的邀請碼`)
};

/**
* | output |
* | --- |
* | "Share your invite code" |
*
* @param {Invite_Page_Step_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_page_step_1 = /** @type {((inputs?: Invite_Page_Step_1Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Page_Step_1Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_page_step_1(inputs)
	if (locale === "ar") return ar_invite_page_step_1(inputs)
	if (locale === "de") return de_invite_page_step_1(inputs)
	if (locale === "es") return es_invite_page_step_1(inputs)
	if (locale === "fr") return fr_invite_page_step_1(inputs)
	if (locale === "it") return it_invite_page_step_1(inputs)
	if (locale === "ja") return ja_invite_page_step_1(inputs)
	if (locale === "ko") return ko_invite_page_step_1(inputs)
	if (locale === "pt_br") return pt_br_invite_page_step_1(inputs)
	if (locale === "ru") return ru_invite_page_step_1(inputs)
	if (locale === "th") return th_invite_page_step_1(inputs)
	if (locale === "tr") return tr_invite_page_step_1(inputs)
	if (locale === "zh_cn") return zh_cn_invite_page_step_1(inputs)
	return zh_tw_invite_page_step_1(inputs)
});